import { defineMessages } from "react-intl";

export default defineMessages({
  back: {
    id: "prompt.goBack"
  },
  leave: {
    id: "prompt.leave"
  },
  title: {
    id: "prompt.title"
  },
});



// WEBPACK FOOTER //
// ./src/components/TransitionModal/translations.js